module.exports = __webpack_public_path__ + "img/pencil-write.f67cea90.svg";